import React from 'react';
import { Box, Button, CircularProgress, Typography, useMediaQuery } from '@mui/material';
import { DialogActions, DialogContent, DialogTitle } from '../dialogs';
import { Dialog } from './dialog';
import { IZone, IZoneLog } from '../../models';
import { theme } from '../../configs';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { usePublicZoneLogs } from '../../pages/zones/zones.hook';
import { CleaningHistoryBlock } from './cleaning-history-block';
import dayjs from 'dayjs';

interface FeedbackDialogProps {
  zone: IZone;
  visible?: boolean;
  setVisible?: (value: boolean) => void;
}

type OrganizedLogs = { [key: string]: IZoneLog[] };
const organizedLogs = (logs: IZoneLog[]): OrganizedLogs => {
  const logsOrganized: OrganizedLogs = {};
  logs.forEach((log) => {
    const date = dayjs(log.created_at).format('dddd, D MMMM YYYY');
    if (!Array.isArray(logsOrganized[date])) {
      logsOrganized[date] = [];
    }

    logsOrganized[date].push(log);
  });

  return logsOrganized;
};

export const CleaningHistoryDialog = (props: FeedbackDialogProps) => {
  const { zone, visible = false, setVisible = () => {} } = props;
  const down_sm = useMediaQuery(theme.breakpoints.down('sm'));
  const [loading_logs, logs] = usePublicZoneLogs({ zoneId: zone.id, limit: 30 });
  const [logsOrganized, setLogsOrganized] = React.useState<OrganizedLogs>({});

  React.useEffect(() => {
    if (logs) {
      setLogsOrganized(organizedLogs(logs));
    }
  }, [logs]);

  const onClose = () => {
    setVisible(false);
  };

  return (
    <Dialog open={visible} onClose={onClose} fullScreen={down_sm}>
      <DialogTitle>
        <Typography color="primary" style={{ fontWeight: 'bold', fontSize: 18, textAlign: 'center' }}>
          Cleaning History
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box>
          {loading_logs ? (
            <CircularProgress size={16} sx={{ marginTop: 0.5 }} />
          ) : (
            Object.keys(logsOrganized).map((date, index) => (
              <Box key={index}>
                <Typography
                  sx={{
                    textAlign: 'right',
                    fontStyle: 'italic',
                    fontWeight: 400,
                    color: 'rgba(102, 102, 102, 1)',
                  }}
                >
                  {date}
                </Typography>
                {logsOrganized[date].map((log) => (
                  <Box key={log.id} sx={{ my: 2 }}>
                    <CleaningHistoryBlock log={log} />
                  </Box>
                ))}
              </Box>
            ))
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button startIcon={<ArrowBackIcon />} color="primary" sx={{ marginTop: 1 }} onClick={() => setVisible(false)}>
          Go Back
        </Button>
      </DialogActions>
    </Dialog>
  );
};
